import PropTypes from "prop-types";

import styled from "styled-components/macro";

import amexBg from "Payments/CreditCardAssets/CardBackgrounds/amex_bg.jpg";
import discoverBg from "Payments/CreditCardAssets/CardBackgrounds/discover_texture.jpg";
import amexLogo from "Payments/CreditCardAssets/CardTypeIcons/amex_logo.png";
import discoverLogo from "Payments/CreditCardAssets/CardTypeIcons/discover_logo.png";
import mcLogo from "Payments/CreditCardAssets/CardTypeIcons/mc_logo.png";
import visaLogo from "Payments/CreditCardAssets/CardTypeIcons/visa_logo.png";

FnrPaymentMethodIcon.propTypes = {
  cardType: PropTypes.string,
};

export default function FnrPaymentMethodIcon({ cardType }) {
  if (!cardType || typeof cardType !== "string") {
    return <Wrapper></Wrapper>;
  }

  switch (cardType.toString().toLowerCase()) {
    case "visa":
      return (
        <VisaWrapper>
          <Logo src={visaLogo} />
        </VisaWrapper>
      );
    case "mastercard":
      return (
        <MCWrapper>
          <Logo src={mcLogo} />
        </MCWrapper>
      );
    case "amex":
      return (
        <AmexWrapper>
          <Logo src={amexLogo} />
        </AmexWrapper>
      );
    case "discover":
      return (
        <DiscoverWrapper>
          <Logo src={discoverLogo} />
        </DiscoverWrapper>
      );
    case "checking":
    case "savings":
      return (
        <BankWrapper>
          <span className="fas fa-university" />
        </BankWrapper>
      );
    default:
      return <Wrapper></Wrapper>;
  }
}

const Wrapper = styled.div`
  background-image: linear-gradient(to top right, #243545, #384653);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const VisaWrapper = styled(Wrapper)`
  background-image: linear-gradient(to bottom left, #21a2cc, #0375a6);
`;

const MCWrapper = styled(Wrapper)`
  background-image: linear-gradient(to top right, #243545, #384653);
`;

const AmexWrapper = styled(Wrapper)`
  background-image: url(${amexBg});
  background-size: auto 120px;
  background-position: bottom right;
`;

const DiscoverWrapper = styled(Wrapper)`
  background-image: url(${discoverBg});
  background-size: auto 200px;
  background-position: center center;
`;

const Logo = styled.img`
  max-width: 80%;
  max-height: 80%;
  position: relative;
  z-index: 2;
  ${AmexWrapper} & {
    max-width: 92%;
    margin-top: 2px;
  }
`;

const BankWrapper = styled(Wrapper)`
  span {
    color: #ffffff;
  }
`;
